import { app } from '@ibgroup-tws-webapps/ratio.ui';

export function shouldShowRestricted(): boolean {
  return !!app.abFeatures?.hasFeature('FT_SHOW_RESTRICTED');
}

export function getInternalHeaders(): HeadersInit {
  return shouldShowRestricted() ? { 'x-internal': 'true' } : {};
}
